<script>
import formInput from "@/mixins/shared/formInput";
import CkeditorConfig from "@wielink-application/shared/js/ckeditor/ckeditor-config";

export default {
	mixins: [formInput],
	props: {
		'config': {
			type: Object,
			required: false,
			default: CkeditorConfig
		},
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	},

	data() {
		return {
			internalChange: false,
			initialised: false
		}
	},

	async mounted() {
		this.initialiseWysiwyg();

		this.$watch('modelValue', async() => {
			if(this.internalChange) {
				return;
			}
			
			if (!this.initialised) {
				await new Promise((resolve) => $(this.$el).on('initialised', () => resolve()));
			}

			let wysiwyg = $(this.$refs.input).data('wysiwyg');
			wysiwyg.setData(this.modelValue);
		});
	},

	methods: {
		async initialiseWysiwyg() {
			let wysiwyg = await ClassicEditor
				.create(this.$refs.input, this.config)
				.catch(error => console.log(error));

			$(this.$refs.input).data('wysiwyg', wysiwyg);

			wysiwyg.model.document.on('change:data', this.setValueOnChange.bind(this, wysiwyg));

			this.initialised = true;
		},

		setValueOnChange(wysiwyg) {
			this.internalChange = true;

			let value = wysiwyg.getData();

			this.changeModelValueTo(value);

			this.$nextTick(() => {
				this.internalChange = false;
			});
			this.initialised = true;
		}
	}
}
</script>

<template>
	<div :class="{'ckeditor-has-error' : hasError }">
		<div ref="input" v-html="modelValue"></div>
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>